import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {UnsavedChangesInterface} from "../models/unsaved-changes.interface";

/**
 * Guard chroniący przed niezamierzoną utratą wprowadzonych danych.
 * Wykorzystuje interfejs CanDeactivate do przechwycenia próby opuszczenia aktualnego
 * widoku/komponentu. Wymaga od chronionego komponentu implementacji kontraktu
 * UnsavedChangesInterface.
 */
@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<UnsavedChangesInterface> {
  constructor() {
  }

  /**
   * Ewaluuje stan modyfikacji bieżącego komponentu przed zezwoleniem na nawigację
   * do innej ścieżki w aplikacji.
   * W przypadku wykrycia niezapisanych zmian, wstrzymuje routing i deleguje
   * wyświetlenie monitu potwierdzającego do samego komponentu.
   *
   * @param component Instancja opuszczanego komponentu (musi implementować UnsavedChangesInterface).
   * @param currentRoute Migawka aktualnie opuszczanej ścieżki.
   * @param currentState Migawka aktualnego stanu routera.
   * @param nextState Opcjonalna migawka docelowego stanu routera (gdzie użytkownik próbuje przejść).
   * @returns Wartość logiczna (true - zezwala na nawigację, false - blokuje nawigację).
   */
  canDeactivate(component: UnsavedChangesInterface,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.hasUnsavedChanges) {
      component.handleUnsavedChangesQuestion(nextState.url);
      return false;

    } else {
      component.childComponentsCancellation();
      return true;
    }

  }

}
